import React from 'react';
import styled, { useTheme } from 'styled-components';
import MetodoPago from '../components/MetodoPago'
import DebitCardImg from '../assets/cards.json';
import Spacer from '../components/Spacer';
import Button from '../components/Button';
import { useLocation } from 'react-router-dom';
import useFormStore from '../state/useFormStore';
import withAuthAndData from '../components/withAuthAndData';
import Lottie from 'lottie-react';

const Wrapper = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  padding-bottom: 100px;
`;

const MainText = styled.div`
  margin: 30px 0 0 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: #333;
  text-align: center;
`;

const Subtext = styled.h4`
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
  color: #666;
  margin: 0 0 40px 0;
  text-align: center;
  width: 80%;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const Collection: React.FC = () => {
  const { first_name } = useFormStore(state => ({ 
    first_name: state.first_name
  }));

  return (
    <Wrapper>
      <Lottie animationData={DebitCardImg} style={{ width:'200px'}}/> 
      <MainText>Necesitamos tu tarjeta de débito</MainText>
      <MetodoPago />
      <Spacer size={80} />
    </Wrapper>
  );
};

export default withAuthAndData(Collection);
